import React, { useEffect, useState } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import { useDispatch, useSelector } from 'react-redux';
import { adTermsRequest, termsLisitingRequest } from '../terms-and-condition/redux/termsDispatcher';

const TermsAndConditionEditor = () => {
    const dispatch = useDispatch();
    const gdprListing = useSelector((state) => state.termsReducer?.termsListing || []);

    const [htmlContent, setHtmlContent] = useState('');

    useEffect(() => {
        dispatch(termsLisitingRequest());
    }, [dispatch]);

    useEffect(() => {
        console.log("DATDTADTADTADADTATATTA:::::::", gdprListing);
        if (gdprListing.length > 0) {
            setHtmlContent(gdprListing[0].html_text || '');
        }
    }, [gdprListing]);

    const handleSave = () => {
        const data = {
            html_text: htmlContent,
            gdpr_key: "terms"
        };

        if (gdprListing.length > 0 && gdprListing[0]?.id) {
            data.id = gdprListing[0].id;
        }

        dispatch(adTermsRequest(data));
    };

    return (
        <div style={{ padding: '20px', maxWidth: '900px', margin: 'auto' }}>
            <h3 style={{ marginBottom: '16px' }}>Terms And Conditions HTML Editor</h3>

            <CKEditor
                editor={ClassicEditor}
                data={htmlContent}
                onChange={(event, editor) => {
                    setHtmlContent(editor.getData());
                }}
            />

            <button
                onClick={handleSave}
                style={{
                    marginTop: '20px',
                    backgroundColor: '#000',
                    color: '#fff',
                    border: 'none',
                    padding: '10px 24px',
                    borderRadius: '5px',
                    cursor: 'pointer',
                }} 
            >
                Save Terms And Condition
            </button>
        </div>
    );
};

export default TermsAndConditionEditor;
